export default __webpack_public_path__ + "static/media/golden-hand.a0c289ff.png";